<div class="node-wrapper">
  <div class="node-content">
    <ng-container #nodeContainer />
  </div>
</div>
